// -*- Mode: rjsx -*-

import React, { useState, useRef, useEffect }  from 'react';
// import TextField from '@mui/material/TextField';


import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import SyncIcon from '@mui/icons-material/Sync';
import CheckIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import WarningIcon from '@mui/icons-material/Warning';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Tooltip from '@mui/material/Tooltip';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

import axios from 'axios';
import qs from 'qs';

import { FHMaterialStyles } from "../ui/fh-material-styles.js";
import { getElementForCorrection } from "./FancyTextEntryUtils.js";

import { API } from '../api';

const LANGUAGE = "en-US";
const CORRECTIONS_URL = "http://localhost:8081/v2/check";
const CORRECTIONS_CLASS = "automated-correction";
const CORRECTIONS_POPUP_CLASS = "automated-correction-popup";

const STATUS_GOOD       = 1; // We're good.
const STATUS_DIRTY      = 2; // we need to check
const STATUS_CHECKING   = 3; // we are checking
const STATUS_BAD        = 4; // we have issues

/////////////////////////////////////////

function getCorrections(text) {
	let postData = qs.stringify({ text: text, language: LANGUAGE });
    let url = CORRECTIONS_URL;
	return axios({
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		data: postData,
		url: url
    }).then((data) => data.data);
}


function ReplacementContext(props) {

    let context = props.context;
    return (
        <Box m={2}>
          <span>{context.text.substring(0, context.offset)}</span>
          <span style={{fontWeight: "bold"}}>{context.text.substring(context.offset, context.offset + context.length)}</span>
          <span>{context.text.substring(context.offset + context.length)}</span>
        </Box>
    );
}

function ReplacementOptions(props) {
    const classes = FHMaterialStyles();
    if(!props.match) { return null; }
    let match = props.match;
    
    return (
        <div className={classes.chips}>
          { match.replacements.map(r => <Replacement
                                          doCorrect={props.doCorrect}
                                          replacement={r} />) }
        </div>
    );
}

function Replacement(props) {
    let r = props.replacement;
    return <Chip
             label={r.value}
             onClick={() => props.doCorrect(r) } />;
}

function CorrectionPopup(props) {
    let match = props.data.match;
    console.log("props.data: %o", props.data);

    let pos = { top: props.data.top, left: props.data.left };
    console.log("pos: %o, ", pos);
    console.log("anchor: %o, ", props.anchor);    
    return (
        
        <Popover
          onClose={props.handlePopupClose}
          anchorReference="position"
          anchorEl={props.anchor}
          open={props.isOpen}
          anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
          }}
        >
          <Box m={2}>
            <Typography variant="h6">{match.shortMessage}</Typography>
            <Typography variant="subtitle1">{match.message}</Typography>

            <ReplacementContext context={match.context} />
            
            <ReplacementOptions
              match={match}
              doCorrect={props.doCorrect } />
            
          </Box>
          
        </Popover>
    );

    
}


function CorrectionIcon(props) {
    
    switch(props.status) {
        
    case STATUS_GOOD:
        return <Tooltip arrow={true} title="Looks great!"><CheckIcon style={{ color: "#6BDE9E" }} /></Tooltip>;

    case STATUS_DIRTY:
        return <Tooltip arrow={true} title="Time to run spell check..."><SpellcheckIcon style={{ color: "#eac11c" }}  /></Tooltip>;
        
    case STATUS_CHECKING:
        return <SyncIcon />; 

    case STATUS_BAD:
        return <Tooltip arrow={true} title="Looks like there are some issues..."><WarningIcon style={{ color: "#EAB43C" }} /></Tooltip>;

    default:
        console.log("props: %o", props);
        // throw("Unknown correction icon: %s", props.status);
        return <HourglassEmptyIcon />;
    }
    
}



function CorrectionBadge(props) {

    return (
        <Badge badgeContent={props.issueCount}>
          <CorrectionIcon status={props.status} />
        </Badge>
    );
    
}

function CorrectionStatus(props) {
    const classes = FHMaterialStyles();

    return (
        <Grid container
              className={classes.fancyTextInputFooter}
              alignItems="center"
              justifyContent="flex-end" >
          <Grid item xs={6}>
            { props.footer }
          </Grid>
          <Grid item xs={5}>
            <Button size="small" className={classes.margin} onClick={props.doCheck}>Check Spelling &amp; Grammar</Button>
          </Grid>          
          <Grid item xs={1}>
            <CorrectionBadge
              status={props.status}
              needsCheck={props.needsCheck}
              issueCount={props.issueCount}
            />
          </Grid>
        </Grid>
    );

}



function FancyTextEntry(props) {

    const [activeMatch, setActiveMatch] = useState(null);
    const [issues, setIssues] = useState([]);
    const [status, setStatus] = useState(STATUS_GOOD);
    const [needsCheck, setNeedsCheck] = useState(false);
    const [cachedValue, setCachedValue] = useState(undefined);    

    const ref = useRef('');
    
    const classes = FHMaterialStyles();

    /* i guess that i thought there'd be more UI methods... */
    const UI = {
        clearCorrections: function() {
            // console.log(new Error().stack);
            Array.from(document.getElementsByClassName(CORRECTIONS_CLASS)).forEach( (element, id) => {
                element.remove();
            });
        }
    };

    useEffect(() => {
        
        if(props.cacheKey && !cachedValue) {
            setCachedValue(API.cache.get(props.cacheKey));
            setStatus(STATUS_DIRTY);
        }

        if(issues) 
            highlightMatches(issues);
        
        return function cleanup() {
            // setIssues([]);
            if(!props.showing && issues.length) {
                console.log("clearing corrections");
                UI.clearCorrections();
            }
            if(issues.length) {
                
                // console.log("cleanup(): issues: %o, activeMatch: %o",issues, activeMatch);
                // UI.clearCorrections();
            }
        };
    });

    
    function doCorrect(d) {
        if(!activeMatch) return;
        let match = activeMatch.match;
        let currentValue = ref.current.value;
        
        let text = currentValue.substring(0, match.offset);
        text += d.value;
        text += currentValue.substring(match.offset + match.length);

        ref.current.value = text;

        UI.clearCorrections();
        setActiveMatch(null);
        updateCache();
        change(null);
        check();
        console.log("didcorrect");
    }
    
    function change(e) {
        ref.current.style.height = "auto";
        ref.current.style.height = (ref.current.scrollHeight) + "px";

        setIssues([]);
        UI.clearCorrections();        

        if(props.onChange) {
            props.onChange(ref.current.value, issues.length);
        }
        
        if(ref.current.value.length && (status != STATUS_DIRTY)) {
            setStatus(STATUS_DIRTY);
//            check();
        }

    }


    function updateCache() {
        // cache the value
        if(props.cacheKey) {
            API.cache.set(props.cacheKey, ref.current.value);
        }        
    }

    function blur(e) {
        e.preventDefault();
        updateCache();                
        if(!activeMatch && !issues) {
            check();
        }
    }


    function setupListeners(match, rect) {
        // show the popup on click                    
        rect.addEventListener('click', (e) => {
            
            e.preventDefault();

            let activeMatch = { match: match,
                                event: e,
                                target: e.target,
                                // top: e.clientY  + window.scrollY,
                                // left: e.clientX  - window.scrollX                             
                                top: e.clientY,
                                left: e.clientX
                              };

            setActiveMatch(activeMatch);
        });
    }


    function highlightMatches(matches) {
        let instance = Math.floor(Math.random() * 10000);
        matches.forEach( m => {
            // put the cursor in the right spot
            try { 
                ref.current.focus();
                ref.current.setSelectionRange(m.offset, m.offset);
            }
            catch (error) {
                console.warn(error);
            }
            
            // get an element positioned at the cursor
            var rect = getElementForCorrection(ref.current, m.offset, m.length, instance, CORRECTIONS_CLASS);
            
            // listen for the click on the correction
            setupListeners(m, rect);
        });
    }
    
    function click(e) {
        e.preventDefault();
        setActiveMatch(null);
    }

    function popupClose(e) {
        return setActiveMatch(null);
    }


    function recvCorrections(data) {

        // set matches, even if empty
        setIssues(data.matches);

        // if we don't receive anything, great!
        if(!data.matches.length)
            setStatus(STATUS_GOOD);

        // otherwise, highlight the issues
        else {
            setStatus(STATUS_BAD);
            highlightMatches(data.matches);
        }
    }
    
    
    function check() {
//        console.log("check(): status: %o, dirty: %o", status, STATUS_DIRTY);
        setStatus(STATUS_CHECKING);
        getCorrections(ref.current.value).then(recvCorrections);
    }

    window.onresize = function() {
        console.log("resized.");
        UI.clearCorrections();
        change();
        highlightMatches(issues);
    };

    if(props.showing)
        return (
            <div style={{ padding: 0, margin: 0 }} >
              <textarea
                spellcheck="false"
                ref={ref}
                onClick={click}
                onBlur={blur}
                className={classes.fancyTextInput} 
                onChange={change}
                defaultValue={props.defaultValue || cachedValue}></textarea>
              { activeMatch &&
              <CorrectionPopup
                anchor={activeMatch.event.target}
                data={activeMatch}
                doCorrect={doCorrect}
                handlePopupClose={popupClose}
                isOpen={activeMatch === null ? false : true}
              /> }
              
              <CorrectionStatus
                footer={props.footer}
                status={status}
                issueCount={issues.length}
                doCheck={check} />
            </div>
        );
    
    else
        return null;

}

export default FancyTextEntry;

